(function(){
  var TARGET_FORM_ID   = 'YignZ6';
  var SF_ORG_ID        = '00D41000000FeLR';
  var SF_ENDPOINT      = 'https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&orgId=00D41000000FeLR';
  var SF_RECORD_TYPE   = '012UH00000AbmeD';
  var SF_FIELD_CBT     = '00NUH00000CZf9R';
  var SF_FIELD_CHANNEL = '00N5d00000JFp6f';

  var accumulatedData = {};

  function findValue(meta, keys) {
    for (var i = 0; i < keys.length; i++) {
      if (meta[keys[i]] !== undefined && meta[keys[i]] !== '') {
        return meta[keys[i]];
      }
    }
    return '';
  }

  function postToSalesforce(meta) {
    // Try every possible key variation Klaviyo might use
    // Keys confirmed via console log on live Shed Liquidators site
    var firstName = meta['$first_name']        || '';
    var lastName  = meta['']                   || '(Not provided)';
    var email     = meta['$email']             || '';
    var phone     = meta['$phone_number']      || '';
    var message   = meta['contact us note']    || '';
    var timezone  = meta['$timezone']          || '';
    var calltime  = meta['$consent_timestamp'] || '';
    var zip       = meta['$zip']               || meta['zip'] || meta['Zip Code'] || meta['zip_code'] || '';
    var preferredCallBack = [timezone, calltime].filter(Boolean).join(' \u2014 ');

    var fields = {
      'oid':         SF_ORG_ID,
      'retURL':      '',
      'first_name':  firstName,
      'last_name':   lastName,
      'email':       email,
      'phone':       phone,
      'description': message,
      'zip':         zip,
      'lead_source': 'Website',
      'recordType':  SF_RECORD_TYPE
    };
    fields[SF_FIELD_CBT]     = preferredCallBack;
    fields[SF_FIELD_CHANNEL] = 'Shed Liquidators';

    // Hidden iframe form POST — bypasses DataDome bot protection
    var iframeName = 'sf_' + Date.now();
    var iframe = document.createElement('iframe');
    iframe.name = iframeName;
    iframe.style.display = 'none';
    document.body.appendChild(iframe);

    var form = document.createElement('form');
    form.method = 'POST';
    form.action = SF_ENDPOINT;
    form.target = iframeName;
    form.style.display = 'none';

    Object.keys(fields).forEach(function(key) {
      var input   = document.createElement('input');
      input.type  = 'hidden';
      input.name  = key;
      input.value = fields[key];
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();

    setTimeout(function() {
      if (document.body.contains(form))   document.body.removeChild(form);
      if (document.body.contains(iframe)) document.body.removeChild(iframe);
    }, 5000);
  }

  window.addEventListener('klaviyoForms', function(e) {
    if (!e.detail || e.detail.formId !== TARGET_FORM_ID) return;

    // Accumulate metaData from every stepSubmit
    if (e.detail.type === 'stepSubmit' && e.detail.metaData) {
      Object.assign(accumulatedData, e.detail.metaData);
    }

    // On final submit — merge and POST to SF
    if (e.detail.type === 'submit') {
      if (e.detail.metaData) {
        Object.assign(accumulatedData, e.detail.metaData);
      }
      postToSalesforce(accumulatedData);
      accumulatedData = {};
    }
  });

})();
